((function () {
    
    const isStrNotEmpty = (str) => typeof str === 'string' && str.trim() !== '';
    document.addEventListener('adev:variant-picker-change', function (event) {
        const variantId = event.detail.variantId;

        document.querySelectorAll('[data-adev-main-product]').forEach(function (productEl) {

            const variantsBadgeDataEl = productEl.querySelector('[data-adev-variants-badge-data]');
            if (!variantsBadgeDataEl) return;

            const variantsBadgeData = JSON.parse(variantsBadgeDataEl.innerHTML);

            const optionsEl = productEl.querySelectorAll('[data-adev-variant-option]');
            if (!optionsEl) return;

            optionsEl.forEach(function (optionEl) {
                const badgeEl = optionEl.querySelector('[data-adev-variant-badge]');
                if (!badgeEl) return;

                badgeEl.innerHTML = '';
            });

            const badgeData = variantsBadgeData[variantId];
            if (!badgeData || !isStrNotEmpty(badgeData.badge)) return;

            const badgeText = badgeData.badge;
            

            optionsEl.forEach(function (optionEl) {
                const badgeEl = optionEl.querySelector('[data-adev-variant-badge]');
                if (!badgeEl) return;

                badgeEl.innerHTML = badgeText;
            });

        });

    });

})());